// Mutators
import './mutators/updateKeyStrokeCounterViewStateMutator';

export { default as KeyStrokeCounterPlugin } from './plugin/KeyStrokeCounterPlugin';
